import React from 'react';
import PropTypes from 'prop-types';
import Popup from "../../../../components/WMS/Mobile/Popup";
import {Grid} from "@mui/material";
import {FormattedMessage} from "react-intl";
import CustomButton from "../../../../components/CustomButton";

CcErrorModal.propTypes = {

};

function CcErrorModal({open, handleClose}) {
    return (
        <Popup
            open={open}
            onClose={handleClose}
            title={<FormattedMessage id={"wms.ccReception.errorModal.title"}/>}
            subtitle={<FormattedMessage id={"wms.ccReception.errorModal.subtitle"}/>}
        >
            <CustomButton
                fullWidth
                onClick={() => handleClose()}
            >
                <FormattedMessage id={"wms.ccReception.errorModal.validButtonLabel"}/>
            </CustomButton>
        </Popup>
    );
}

export default CcErrorModal;